// If required fields are added to the config make sure
// to map them here to the correct response path.
interface ConfigMapping {
  [key: string]: string
}

export const configMapping: ConfigMapping = {
  // =========================
  // orderResponse
  // =========================
  // orderConfirmation
  'orderConfirmation.confirmationId': 'Payload.ConfirmationId',
  'orderConfirmation.department': 'Payload.SellerInformation.Department',
  'orderConfirmation.name': 'Payload.SellerInformation.Contact.Name',
  'orderConfirmation.phone': 'Payload.SellerInformation.Contact.Phone',
  'orderConfirmation.email': 'Payload.SellerInformation.Contact.Email',
  'orderConfirmation.remarks': 'Payload.Remarks',

  // editOrderItem
  'editOrderItem.confirmationItemId': 'Payload.Items[index].ConfirmationItemId',
  'editOrderItem.confirmationCountryOfOrigin':
    'Payload.Items[index].ConfirmationCountryOfOrigin',
  'editOrderItem.confirmationSellerProductId':
    'Payload.Items[index].ConfirmationSellerProductId',
  'editOrderItem.confirmationSellerProductDescription':
    'Payload.Items[index].ConfirmationSellerProductDescription',
  'editOrderItem.confirmationQuantity':
    'Payload.Items[index].ConfirmationQuantity',
  'editOrderItem.confirmationUnit': 'Payload.Items[index].ConfirmationUnit',
  'editOrderItem.confirmationPriceBaseQuantity':
    'Payload.Items[index].ConfirmationPriceBaseQuantity',
  'editOrderItem.confirmationPriceUnitOfMeasure':
    'Payload.Items[index].ConfirmationPriceUnitOfMeasure',
  'editOrderItem.confirmationPrice': 'Payload.Items[index].ConfirmationPrice',
  'editOrderItem.confirmationPriceSum':
    'Payload.Items[index].ConfirmationPriceSum',
  'editOrderItem.confirmationAllowanceChargeSum':
    'Payload.Items[index].ConfirmationAllowanceChargeSum',
  'editOrderItem.confirmationLineItemAmount':
    'Payload.Items[index].ConfirmationLineItemAmount',
  'editOrderItem.confirmationDeliveryDate':
    'Payload.Items[index].ConfirmationDeliveryDate',

  // =========================
  // despatchAdvice
  // =========================
  // deliveryConfirmation
  'deliveryConfirmation.deliveryNoteNumber': 'Payload.DeliveryNoteNumber',
  'deliveryConfirmation.deliveryDate': 'Payload.DeliveryDate',
  'deliveryConfirmation.gln': 'Payload.CarrierInformation.GLN',
  'deliveryConfirmation.company': 'Payload.CarrierInformation.Company',
  'deliveryConfirmation.department': 'Payload.SellerInformation.Department',
  'deliveryConfirmation.name': 'Payload.SellerInformation.Contact.Name',
  'deliveryConfirmation.phone': 'Payload.SellerInformation.Contact.Phone',
  'deliveryConfirmation.email': 'Payload.SellerInformation.Contact.Email',
  'deliveryConfirmation.notes': 'Payload.Notes',

  // editDespatchAdviceItem
  'editDespatchAdviceItem.confirmationItemId':
    'Payload.Items[index].ConfirmationItemId',
  'editDespatchAdviceItem.confirmationCountryOfOrigin':
    'Payload.Items[index].ConfirmationCountryOfOrigin',
  'editDespatchAdviceItem.confirmationSellerProductId':
    'Payload.Items[index].ConfirmationSellerProductId',
  'editDespatchAdviceItem.confirmationSellerProductDescription':
    'Payload.Items[index].ConfirmationSellerProductDescription',
  'editDespatchAdviceItem.confirmationQuantity':
    'Payload.Items[index].ConfirmationQuantity',
  'editDespatchAdviceItem.deliveryStatus':
    'Payload.Items[index].DeliveryStatus',
  'editDespatchAdviceItem.confirmationUnit':
    'Payload.Items[index].ConfirmationUnit',
  'editDespatchAdviceItem.confirmationPriceBaseQuantity':
    'Payload.Items[index].ConfirmationPriceBaseQuantity',
  'editDespatchAdviceItem.confirmationPriceUnitOfMeasure':
    'Payload.Items[index].ConfirmationPriceUnitOfMeasure',
  'editDespatchAdviceItem.confirmationPrice':
    'Payload.Items[index].ConfirmationPrice',
  'editDespatchAdviceItem.confirmationPriceSum':
    'Payload.Items[index].ConfirmationPriceSum',
  'editDespatchAdviceItem.confirmationAllowanceChargeSum':
    'Payload.Items[index].ConfirmationAllowanceChargeSum',
  'editDespatchAdviceItem.confirmationLineItemAmount':
    'Payload.Items[index].ConfirmationLineItemAmount',
  'editDespatchAdviceItem.confirmationDeliveryDate':
    'Payload.Items[index].ConfirmationDeliveryDate',

  // =========================
  // invoice
  // =========================
  // invoiceData
  'invoiceData.invoiceNumber': 'Payload.InvoiceNumber',
  'invoiceData.department': 'Payload.SellerInformation.Department',
  'invoiceData.name': 'Payload.SellerInformation.Contact.Name',
  'invoiceData.phone': 'Payload.SellerInformation.Contact.Phone',
  'invoiceData.email': 'Payload.SellerInformation.Contact.Email',
  'invoiceData.notes': 'Payload.Notes',

  // summary
  'summary.confirmationTotalNetItemAmount':
    'Payload.ConfirmationTotalNetItemAmount',
  'summary.confirmationSurcharge': 'Payload.ConfirmationSurcharge',
  'summary.confirmationNetAmount': 'Payload.ConfirmationNetAmount',
  'summary.confirmationTaxRate': 'Payload.ConfirmationTaxRate',
  'summary.confirmationTaxValue': 'Payload.ConfirmationTaxValue',
  'summary.confirmationInvoiceAmount': 'Payload.ConfirmationInvoiceAmount',

  // editInvoiceItem
  'editInvoiceItem.confirmationItemId':
    'Payload.Items[index].ConfirmationItemId',
  'editInvoiceItem.confirmationCountryOfOrigin':
    'Payload.Items[index].ConfirmationCountryOfOrigin',
  'editInvoiceItem.confirmationSellerProductId':
    'Payload.Items[index].ConfirmationSellerProductId',
  'editInvoiceItem.confirmationSellerProductDescription':
    'Payload.Items[index].ConfirmationSellerProductDescription',
  'editInvoiceItem.confirmationQuantity':
    'Payload.Items[index].ConfirmationQuantity',
  'editInvoiceItem.confirmationUnit': 'Payload.Items[index].ConfirmationUnit',
  'editInvoiceItem.confirmationPriceBaseQuantity':
    'Payload.Items[index].ConfirmationPriceBaseQuantity',
  'editInvoiceItem.confirmationPriceUnitOfMeasure':
    'Payload.Items[index].ConfirmationPriceUnitOfMeasure',
  'editInvoiceItem.confirmationPrice': 'Payload.Items[index].ConfirmationPrice',
  'editInvoiceItem.confirmationPriceSum':
    'Payload.Items[index].ConfirmationPriceSum',
  'editInvoiceItem.confirmationAllowanceChargeSum':
    'Payload.Items[index].ConfirmationAllowanceChargeSum',
  'editInvoiceItem.confirmationLineItemAmount':
    'Payload.Items[index].ConfirmationLineItemAmount',
  'editInvoiceItem.confirmationDeliveryDate':
    'Payload.Items[index].ConfirmationDeliveryDate',

  // =========================
  // deliveryCallOff
  // =========================
  // dataForConfirmation
  'dataForConfirmation.confirmationId': 'Payload.ConfirmationId',
  'dataForConfirmation.department': 'Payload.Department',
  'dataForConfirmation.contactName': 'Payload.ContactName',
  'dataForConfirmation.contactPhone': 'Payload.ContactPhone',
  'dataForConfirmation.contactMail': 'Payload.ContactMail',

  // =========================
  // deliveryDespatchAdvice
  // =========================
  // dataForDeliveryForecastDespatchAdvice
  'dataForDeliveryForecastDespatchAdvice.deliveryNoteNumber':
    'Payload.DeliveryNoteNumber',
  'dataForDeliveryForecastDespatchAdvice.deliveryDate': 'Payload.DeliveryDate',
  'dataForDeliveryForecastDespatchAdvice.confirmationGrossWeight':
    'Payload.ConfirmationGrossWeight',
  'dataForDeliveryForecastDespatchAdvice.confirmationGrossWeightUnit':
    'Payload.ConfirmationGrossWeightUnit',
  'dataForDeliveryForecastDespatchAdvice.confirmationNumberOfUnits':
    'Payload.ConfirmationNumberOfUnits',

  // articleDetail
  'articleDetail.confirmationQuantity':
    'Payload.Items[index].ConfirmationQuantity',
  'articleDetail.deliveryStatus': 'Payload.Items[index].DeliveryStatus',
  'articleDetail.confirmationNetWeight':
    'Payload.Items[index].ConfirmationNetWeight',
  'articleDetail.confirmationNetWeightUnit':
    'Payload.Items[index].ConfirmationNetWeightUnit',
  'articleDetail.confirmationCountryOfOrigin':
    'Payload.Items[index].ConfirmationCountryOfOrigin',

  // =========================
  // Shared paths
  // =========================
  // attachment
  'attachment.attachments': 'Attachments',
}
